import { useMutation } from '@tanstack/react-query';
import { generateCommunityDetails } from '../communities.service';
export const useGenerateCommunityDetails = () => {
    return useMutation({
        mutationFn: (url) => generateCommunityDetails(url),
    });
};
